'use client';

import React, { useEffect, useRef } from 'react';

const stats = [
  {
    val: '1/3',
    desc: 'The cost of one fully loaded US hire, per dedicated rep per month, with the system included. Published on the pricing page.',
  },
  {
    val: 'Phone first',
    desc: 'A trained rep dialing your market daily, with email and LinkedIn in support and every meeting graded against a written definition.',
  },
  {
    val: '0',
    desc: 'Recruiting fees, ramp salaries, severance events, or re-hiring cycles. Ever.',
  },
];

export default function PermanentFunctionSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24">
      <div className="max-w-site mx-auto px-7">
        <div className="rev mb-13 max-w-[780px]">
          <div className="eyebrow">The permanent SDR function</div>
          <h2 className="heading-2 text-ink">Built to be the whole department</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {stats?.map((s, i) => (
            <div
              key={s?.val}
              className="rev stat-card bg-white border border-line-color rounded-brand p-6"
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <b>{s?.val}</b>
              <span>{s?.desc}</span>
            </div>
          ))}
        </div>

        <div className="rev gold-strip mt-8" style={{ transitionDelay: '0.24s' }}>
          <div>
            <b className="text-primary">This is not a bridge.</b> Your reps, your playbook, and your
            reporting are built to run for years. If your deal size grows into supporting internal
            headcount later, everything we built transfers.
          </div>
        </div>
      </div>
    </section>
  );
}